import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    text: 'Mi hijo de 14 años pasó de sacar 6s a 9s en un trimestre. Lo más increíble es que él mismo pidió hacer el protocolo de nuevo.',
    author: 'María G.',
    role: 'Madre de Alejandro, 14 años',
    stars: 5
  }, {
    text: 'Pensé que era un problema de disciplina, pero era un problema de entrenamiento. Enfoque de Acero le dio las herramientas que yo no sabía cómo darle.',
    author: 'Carlos R.',
    role: 'Padre de Sofía, 12 años',
    stars: 5
  }, {
    text: 'En 21 días mi hija terminó su primer proyecto personal completo. Algo que llevaba 6 meses intentando empezar. El cambio de actitud es total.',
    author: 'Laura M.',
    role: 'Madre de Valentina, 16 años',
    stars: 5
  }];
  return <section className="py-20 bg-[#F8FAFC]" data-id="element-143">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <div className="text-center mb-16" data-id="element-145">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl sm:text-4xl font-bold text-[#1B3A6B] mb-4 uppercase" data-id="element-146">
            Lo Que Dicen las Familias
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-147">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 relative" data-id="element-148">
              <Quote className="absolute top-6 right-6 h-8 w-8 text-slate-100" data-id="element-149" />

              <div className="flex gap-1 mb-6" data-id="element-150">
                {[...Array(t.stars)].map((_, i) => <Star key={i} className="h-5 w-5 text-[#F97316] fill-current" data-id="element-151" />)}
              </div>

              <p className="text-slate-700 text-lg mb-6 leading-relaxed italic" data-id="element-152">
                "{t.text}"
              </p>

              <div className="border-t border-slate-100 pt-6" data-id="element-153">
                <p className="font-bold text-[#1B3A6B]" data-id="element-154">{t.author}</p>
                <p className="text-sm text-slate-500" data-id="element-155">{t.role}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}